import React from 'react'
import { Box, Button, Group, LoadingOverlay, Modal, ModalProps, Stack, Text, TextInput } from "@mantine/core"
import { useChangeUserPassword } from '../../hooks/users'
import { useSession } from '../../hooks/redux'

export const ChangePasswordModal = (props: ModalProps) => {
  const { form, mutate, isLoading } = useChangeUserPassword()
  const session = useSession()

  const handleClose = () => {
    form.reset()
    props.onClose()
  }

  return (
    <Modal
      {...props}
      size='1200'
      onClose={handleClose}
      title={<Text style={{ fontSize: 18, fontWeight: 600 }}>{`Change Password for ${session.user.firstName} ${session.user.lastName} in ${session.organization.name}`}</Text>}
    >
      <Stack>
        <form style={{ padding: '20px 10px 10px 10px' }} onSubmit={form.onSubmit((vals => mutate(vals)))}>
          <LoadingOverlay visible={isLoading} />
          <TextInput
            size='lg'
            type='password'
            withAsterisk
            label='Current Password'
            placeholder='Enter your current password'
            key={form.key('current')}
            {...form.getInputProps('current')}
          />
          <TextInput
            size='lg'
            type='password'
            withAsterisk
            label='New Password'
            placeholder='Enter your new password'
            key={form.key('new')}
            {...form.getInputProps('new')}
          />
          <TextInput
            size='lg'
            type='password'
            withAsterisk
            label='Confirm Password'
            placeholder='Confirm your new password'
            key={form.key('confirmed')}
            {...form.getInputProps('confirmed')}
          />

          <Box mt='xl' mb='40px'>
            <Text>
              <Text span fw='bold'>Password Requirements:</Text><br/>
              Passwords must be 8 or more characters: <br/>
              <Text span fw='bold'>It must contain any 3 of the following:</Text> <br/>
              Include 1 upper case letter <br/>
              Include 1 lower case letter <br/>
              Include 1 number <br/>
              Include 1 special character (%, #, @, etc.) <br/>
            </Text>

            <Text fw='bold' my='lg'>
              Additionally: <br/>
              Password must be different from all of your previous passwords.<br/>
              Password cannot be the same as your username or email.<br/>
              Password expires every 10000 days.<br/>
            </Text>
          </Box>

          <Group justify='flex-end'>
            <Button variant='outline' size='lg' onClick={handleClose}>Cancel</Button>
            <Button disabled={isLoading} size='lg' type='submit'>Confirm</Button>
          </Group>
        </form>
      </Stack>
    </Modal>
  )
}
